export const imageAccommodation = {
  breadcrumbCurrent: "Logo del alojamiento",
  heading: "Logo de tu anuncio",
  subtitle:
    "Sube el logo que identifica a este anuncio. Formatos permitidos: PNG, JPG, SVG · máx. 5 MB.",
  savedLogoAlt: "Logo guardado",
  activeBadge: "Logo activo",
  change: "Cambiar",
  drop: {
    release: "Suelta aquí",
    newLogo: "Nuevo logo",
    uploadLogo: "Sube tu logo",
    dragOr: "Arrastra o",
    clickLink: "haz clic",
    formats: "PNG · JPG · SVG · máx. 5 MB",
  },
  importButton: "Importar logo de otro anuncio",
  crop: {
    removeImage: "Quitar imagen",
    tip: "Mueve y ajusta el recorte. Proporción 2:1 (ideal para logos horizontales).",
    saving: "Guardando…",
    save: "Guardar logo",
  },
  actions: {
    cancel: "Cancelar",
  },
  applyModal: {
    title: "¿Aplicar a otros anuncios?",
    subtitle: "Selecciona los anuncios a los que quieres copiar este mismo logo.",
    logoAlt: "Logo",
    selectAll: "Seleccionar todos",
    progress: "Aplicando {done}/{total}…",
    skip: "Omitir",
    applying: "Aplicando…",
    applyToBtn: "Aplicar a {count} anuncio | Aplicar a {count} anuncios",
  },
  importModal: {
    title: "Importar logo",
    subtitle: "Elige el logo de otro anuncio para usarlo en este.",
    loading: "Cargando anuncios…",
    empty: "Ningún anuncio tiene logo todavía.",
    progress: "Importando logo…",
    importing: "Importando…",
  },
  defaultListingName: "Listing",
  toasts: {
    invalidFormat: "Formato no válido. Usa PNG, JPG o SVG.",
    fileTooLarge: "El archivo supera el límite de {max} MB.",
    selectBeforeSave: "Selecciona y ajusta un logo antes de guardar.",
    propertyNotFound: "No se encontró la propiedad asociada a este anuncio.",
    saveSuccess: "Logo guardado con éxito",
    saveError: "Error al guardar el logo.",
    listingLoadError: "No se pudo cargar la información del anuncio.",
    applySuccess:
      "Logo aplicado a {count} anuncio correctamente | Logo aplicado a {count} anuncios correctamente",
    applyError:
      "No se pudo aplicar en {count} anuncio | No se pudo aplicar en {count} anuncios",
    listingsLoadError: "No se pudieron cargar los anuncios.",
    propertyNotFoundImport: "No se encontró la propiedad de este anuncio.",
    importSuccess: 'Logo de "{name}" importado con éxito',
    importError: "Error al importar el logo.",
  },
};
